globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};
appCustomerSpace.Controllers.LocalManagement.Multicast = appCustomerSpace.Controllers.LocalManagement.Multicast || {};


appCustomerSpace.Controllers.LocalManagement.Multicast.ValidationDocumentsFolderController = (function(superClass) {

    utils.extend(ValidationDocumentsFolderController, superClass);

    function ValidationDocumentsFolderController() {
      return ValidationDocumentsFolderController.__super__.constructor.apply(this, arguments);
    }

    $.extend(ValidationDocumentsFolderController.prototype, {
      init: function() {
        this.initEvents();

        return ValidationDocumentsFolderController.__super__.init.apply(this, arguments);
      },
      initEvents: function() {
        var $importBusinessRegistrationCertificateBtn = $('.import-business-registration-certificate-file-btn');
        var $importBusinessRegistrationCertificateInput = $('.import-business-registration-certificate-file-input');

        $importBusinessRegistrationCertificateBtn.on('click', function(e) {
          e.preventDefault();
          $importBusinessRegistrationCertificateInput.trigger('click');
        });

        var $importPublicServiceInvoiceBtn = $('.import-public-service-invoice-file-btn');
        var $importPublicServiceInvoiceInput = $('.import-public-service-invoice-file-input');

        $importPublicServiceInvoiceBtn.on('click', function(e) {
          e.preventDefault();
          $importPublicServiceInvoiceInput.trigger('click');
        });
      },
    });

    return ValidationDocumentsFolderController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
